import { useQuery } from "@tanstack/react-query"
import { useMemo } from "react"
import { WarehouseOperationBlocksApi } from "../api/warehouseOperationBlocks"

export const warehouseInventoryBlocksQueryKey = [
  "wms",
  "warehouses",
  "inventory-blocks",
] as const

export function useWarehouseInventoryBlocks() {
  const query = useQuery({
    queryKey: warehouseInventoryBlocksQueryKey,
    queryFn: () => WarehouseOperationBlocksApi.getInventoryBlockedWarehouses(),
    staleTime: 0,
    refetchOnWindowFocus: true,
  })
  const blockedWarehouseIds = useMemo(
    () => new Set(query.data?.warehouse_ids ?? []),
    [query.data?.warehouse_ids],
  )

  return {
    ...query,
    blockedWarehouseIds,
    ready: query.isSuccess,
    inventoryBlockStatusUnknown: !query.isSuccess,
  }
}
